import { render, staticRenderFns } from "./sidewButton.vue?vue&type=template&id=33845f00&scoped=true"
import script from "./sidewButton.vue?vue&type=script&lang=js"
export * from "./sidewButton.vue?vue&type=script&lang=js"
import style0 from "./sidewButton.vue?vue&type=style&index=0&id=33845f00&prod&lang=less&scoped=true"
import style1 from "./sidewButton.vue?vue&type=style&index=1&id=33845f00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33845f00",
  null
  
)

export default component.exports